import config from '../Common/Configurations/APIConfig';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import auth from '../Common/Configurations/Auth';
import { handleSuccess, handleError } from '../Common/Layout/CustomAlerts';
import Footer from '../Common/Layout/Footer';
import APIConfig from "../Common/Configurations/APIConfig";
const initialFieldValues = {
    email: "",
    domainUrl: ""
};
export default function Forgot() {
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [successStatus, setSuccessStatus] = useState('');
    const [errorStatus, setErrorStatus] = useState('');
    const [btnSubmit, setBtnSubmit] = useState(true);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.email = values.email == '' ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x == true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(false)
            const formData = new FormData()
            formData.append("email", values.email)
            formData.append("domainUrl", window.location.origin)
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            post: (newrecord) => axios.post(APIConfig.APIACTIVATEURL + APIConfig.SENDRESETPASSWORD, newrecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        applicationAPI()
            .post(formData)
            .then((res) => {
                console.log(res.data)
                if (res.data.statusCode === 200) {
                    setSuccessStatus(res.data.message);
                    setBtnSubmit(true);
                    setValues('');
                    setErrorStatus('')
                }
                else {
                    setBtnSubmit(true);
                    setErrorStatus(res.data.message);
                    setSuccessStatus('');
                }
            });
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] == false ? ' form-control-danger' : '';
    return (
        <>
            <div className="auth-back-cover" style={{ backgroundColor: "#39279D" }}>
                <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                    {/* auth-page content */}
                    <div className="auth-page-content overflow-hidden mt-lg-4">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="card overflow-hidden rounded-4 loginbox">
                                        <div className="row g-0">
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <img src="/assets/images/logo3d.jpg"></img>
                                                </div>
                                                <h4 className="mb-2">Forgot Password?</h4>
                                                {successStatus !== "" ? <div class="alert alert-info text-black"> <i class="fas fa-check-circle"></i> {successStatus}</div> : ""}
                                                {errorStatus !== "" ? <div class="alert alert-danger text-black"> <i class="fas fa-check-circle"></i> {errorStatus} </div> : ""}
                                                <p className="mb-0">Enter the email address associated with an account.</p>
                                                <div className="mt-4">
                                                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                                        <div className="mb-3">
                                                            <input className={'form-control' + applyErrorClass('email')} name="email" type="text" value={values.email} onChange={handleInputChange} placeholder="Enter Email" />
                                                            {errors.email === false ? (<div className="validationerror">Please enter email</div>) : ('')}
                                                        </div>
                                                        <div className="mt-4 d-flex justify-content-end">
                                                            {btnSubmit === true ?
                                                                (<button type="submit" className="btn btn-success w-100">Reset Password</button>)
                                                                :
                                                                (<button type="button" className="btn btn-primary w-100" disabled>Please wait...</button>)
                                                            }
                                                        </div>
                                                    </form>
                                                </div>
                                                <div class="mt-5 text-center">
                                                    <p class="mb-0">Don't have an account ? <Link to={"/login"} class="fw-semibold text-primary text-decoration-underline">Back to login</Link></p>
                                                </div>
                                            </div>
                                            {/* end col */}
                                        </div>
                                        {/* end row */}
                                    </div>
                                    {/* end card */}
                                </div>
                                {/* end col */}
                            </div>
                            {/* end row */}
                        </div>
                        {/* end container */}
                    </div>
                    {/* end auth page content */}
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}
